const CHAT_SIDEBAR_COLLAPSED_STORAGE_KEY = 'chatSidebarCollapsed';

// Persists the AI chat history sidebar's collapsed/expanded state to device
// localStorage so the user's choice survives reloads. Defaults to expanded
// (false) when nothing is stored, preserving the prior behavior.
export const getStoredChatSidebarCollapsed = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return localStorage.getItem(CHAT_SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setStoredChatSidebarCollapsed = (collapsed: boolean) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(
      CHAT_SIDEBAR_COLLAPSED_STORAGE_KEY,
      collapsed ? 'true' : 'false'
    );
  } catch {
    // no-op
  }
};
